import { ImageWithFallback } from '~/components/ui/ImageWithFallback';
import { GiAerialSignal } from 'react-icons/gi';
import { DateCountdown } from '~/features/Influencer/DateCountdown';
import React from 'react';

export function InfluencerHeroMobile(props: {
  src: string;
  alt: string;
  hasEnded: boolean;
  nextLive: string | null;
}) {
  return (
    <div className={'sm:hidden relative'}>
      <ImageWithFallback
        src={props.src}
        alt={props.alt}
        className={'h-full w-full object-cover'}
      />

      <div
        className={
          'absolute right-2 bottom-2 left-2 rounded-lg text-white flex items-center px-4 py-2'
        }
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        <GiAerialSignal size={'24px'} />

        <div className={'ml-4'}>
          {props.hasEnded ? (
            <p className={'font-bold text-sm'}>
              <span className={'font-bold text-lg'}>
                Live Sale with {props.alt}
              </span>

              <br />

              <span>Sorry you missed it!</span>
            </p>
          ) : (
            !!props.nextLive && (
              <DateCountdown endTime={props.nextLive} name={props.alt} />
            )
          )}
        </div>
      </div>
    </div>
  );
}
